module.exports = __webpack_public_path__ + "static/media/photo3.0b0f6a62.jpg";